import React from 'react'
import Pane from 'components/Common/Pane'
import Group from 'components/utils/Group'
import { OfferPageFilterType } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import MobileMultipleRoomsIndividualRoomsContent from './MobileMultipleRoomsIndividualRoomsContent'
import MobileMultipleRoomsSameRoomContent from './MobileMultipleRoomsSameRoomContent'
import { isMultipleRoomBookingActive } from 'selectors/offerPage/offerPageSharedSelectors'

interface Props {
  activeFilter?: OfferPageFilterType
  scrollToSelections?: boolean
  headerRef: React.RefObject<HTMLDivElement | null>
  isMultiIndividualRoom: boolean
}

function MobileMultipleRoomsBookingContent(props: Props) {
  const {
    activeFilter,
    scrollToSelections,
    headerRef,
    isMultiIndividualRoom
  } = props

  const isConfirmStep = activeFilter === 'multiRoomConfirm'

  return (
    <Pane background="neutral-six">
      <Group direction="vertical" gap={8}>
        {isMultiIndividualRoom && <MobileMultipleRoomsIndividualRoomsContent />}
        {!isMultiIndividualRoom && <MobileMultipleRoomsSameRoomContent showSelection={!!scrollToSelections && isConfirmStep} headerRef={headerRef} />}
      </Group>
    </Pane>
  )
}

export default withOfferPageAndReduxState((state, appState) => ({
  activeFilter: state.activeFilter,
  isMultiIndividualRoom: isMultipleRoomBookingActive(state, appState),
}), MobileMultipleRoomsBookingContent)
